import React, { useState } from 'react';
import _ from 'lodash';

import ImageTooltip from '../ImageTooltip/ImageTooltip';
import styles from './ImagesCell.module.css';

const formatImages = (images) => {
  const n = _.size(images);
  return `${n} ${n === 1 ? 'Image' : 'Images'}`;
};

const ImagesCell = ({
  images,
  rowId,
  type,
  imagesOpen,
  isEditingRow,
  openTooltip,
  closeTooltip,
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const isGallery = type === 'galleryUrls';
  const showTooltip = `${rowId}-${type}` === imagesOpen;
  const imageList = type === 'imageUrl' && images ? [images] : images;
  const imageListSize = _.size(imageList) > 0;

  const handleClickAdd = () => {
    setIsAdding(true);
    if (!showTooltip) openTooltip();
  };
  const handleCloseTooltip = () => {
    closeTooltip();
    setIsAdding(false);
  };

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={`${styles.button} ${styles.imagesButton}`}
        onClick={openTooltip}
      >
        {formatImages(imageList)}
      </button>
      {isGallery && isEditingRow && (
        <button
          type="button"
          className={`${styles.button} ${styles.addButton}`}
          onClick={handleClickAdd}
        >
          <i className="far fa-plus" id="add-image" />
        </button>
      )}
      {showTooltip && (imageListSize || isAdding) && (
        <ImageTooltip
          images={imageList}
          isGallery={isGallery}
          closeTooltip={handleCloseTooltip}
        />
      )}
    </div>
  );
};

export default ImagesCell;
